import { useMemo } from 'react'
import { useDesignTokenValue } from 'Simple/DesignTokens'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let lineColor = useDesignTokenValue({
    viewPath: props.viewPath,
    path: 'colors.neutral.300',
  })
  let dotColor = useDesignTokenValue({
    viewPath: props.viewPath,
    path: 'colors.neutral.400',
  })

  return useMemo(() => {
    let rv = {
      ...data,
      lineColor: lineColor,
      dotColor: dotColor,
      tagType: 'grey',
      ...props,
    }
    if (rv.history?.length) {
      rv.history[0].isFirst = true
      rv.history[rv.history.length - 1].isLast = true
    }
    return rv
  }, [props, data])
}
